<template>

  <div class="select-customers-dropdown col-md-12 m-bottom-40 mobile-no-m-bottom no-padding-select-customer">

    <confirmation-popup
        title="Notice"
        message="Would you like to  delete this customer and his invoices if exists? "
        id="deleteCustomerModal" confirm-btn-text="Yes" cancel-btn-text="No"
        :teleport="viewBookingAddCustomers ? '#deletePopupTeleport':'body'"
        :before-close="remove_customer_input(customerToRemove)"

        @on-confirm="()=>{}"></confirmation-popup>
    <p v-if="!viewBooking || viewBookingAddCustomers" :class="{'font-size-18 bold m-bottom-30' : true , 'm-top-23': viewBookingAddCustomers}">


      <span class="select-customers-dropdown-title" v-if="canSeeCustomer || loggedUser.role_id  != 1">
        <span v-if="customers.length > 1">Customers</span>
        <span v-else>Customer</span>

         <a>
            <svg data-toggle="modal" data-target="#popupi"
                   @click="showPOPUI"
                   width="20" height="20" style="fill: #CBCFD3; position:relative; bottom: -4px"
                   viewBox="0 0 20 20"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45
                      10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3
                      10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z"
                      fill="#CBCFD3"/>
      </svg>
         </a>
      </span>


      <span v-if="!isMobile && allowMultiCustomers && check_if_can_view_multi_customer_button" @click="addNewCustomer" :class="{'position-relative top-7':true, 'right-':has_bill_payer, 'top-7':!isMobile , 'top-4':isMobile}" style="  cursor: pointer;">
      <span class="float-right">
          <a href="javascript:;">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                  fill="#03A9F4"/> </svg>
          </a>
      </span>
      <span v-show="!isMobile && allowMultiCustomers" class="select-services-dropdown-add-label float-right">Add </span>
  </span>
<span v-show="has_bill_payer" class="float-right" style="margin-right: 20px;">
        <label class="control-label new-design new-label-place m-bottom-12 minimumChargeCheckBoxLabel ">
          Different bill payer
        </label>
        <label class="figma-switch " style="padding: 1px">
        <input type="hidden" name="different_bill_payer" :value="computedValue">
        <input type="checkbox" id="different_bill_payer_visual" @change="showHideBillPayer"
               v-model="show_bill_payer_property">
          <span for="different_bill_payer" class="slider round"></span>
        </label>
          </span>
    </p>

    <span v-for="(customer,counter) in customers" style="margin-top: 10px;">
      <div :class="{'d-block position-relative m-b-lg':true }"
           v-if="canSeeCustomer || loggedUser?.role_id  != 1"
           :key="customer && customer.customer_id? customer.customer_id:counter">
                      <select-customers-dropdown
                          v-model="customers[counter]"
                          :booking-customers="customers"
                          :counter="counter+1"
                          :can_add="can_add"
                          :can_edit="can_edit"
                          :display_icon="true">
                      </select-customers-dropdown>

      <button @click="openDeleteModal(customer)" type="button"
              class="remove_customer_input btn bg-transparent d-flex float-right"
              :class="{'display-none':(customers[counter] && customers[counter].customer_id)}"
              v-show="customers.length > 1 && counter!==0"
              style="    position: absolute;right: 0;top: 2px;">
        <svg data-v-2d9eb739="" data-v-3958b468="" width="20" height="20" viewBox="0 0 20 20" fill="none" >
             xmlns="http://www.w3.org/2000/svg">
          <path data-v-2d9eb739="" data-v-3958b468="" fill-rule="evenodd" clip-rule="evenodd"
                d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
                fill="#03A9F4"></path>
        </svg>
      </button>
    </div>
      <div v-else class="select-customers-dropdown col-md-12 m-bottom-40 mobile-no-m-bottom no-padding-select-customer">
           <span class="select-customers-dropdown-title">Customer details hidden</span>
           <p style="margin-top: 15px; color: rgb(100 98 98); font-size: 17px">Access to customer details is currently disabled by your admin.
            This is not an error. Please contact your admin if you need access.</p>
     </div>
    </span>

    <div class="clearfix"></div>

    <span v-if="isMobile && allowMultiCustomers" @click="addNewCustomer" :class="{'position-relative':true, 'right-8':has_bill_payer, 'top-7':!isMobile , 'top-4':isMobile && !viewBookingAddCustomers, 'top-0':isMobile && viewBookingAddCustomers}" style="  cursor: pointer;">
      <span class="float-right">
          <a href="javascript:;">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path
                  d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
                  fill="#03A9F4"/> </svg>
          </a>
      </span>
      <span class="select-services-dropdown-add-label float-right">Add Customers</span>
  </span>
    <input type="hidden" name="customers" v-model="JSON.stringify(customers)"/>
    <div  v-if="allowMultiCustomers" class="row max-min">
      <p class="capacity col-xs-12">Capacity</p>
      <div class="col-xs-6  minmum">
        <p class=" ">Minimum</p>

          <input type="number" v-model="minCustomersCount" min="0" class="form-control" />
      </div>
      <div class="col-xs-6 maxmum">
        <p class=" ">Maximum</p>
        <input type="number" v-model="maxCustomersCount" min="0" class="form-control" @input="handleMaxCustomersCountChange(maxCustomersCount)"
               @blur="handleMaxCustomersCountChange"
               @keyup.enter="handleMaxCustomersCountChange"/>

      </div>

    </div>
  </div>


</template>

<script>
import {EventBus} from "@/events/event-bus";
import ConfirmationPopup from "@/modules/common/components/ConfirmationPopup.vue";
export default {
    name: "selectCustomers",
    components: {ConfirmationPopup},
    props: {
        can_add: true,
        can_edit: true,
        selectedCustomerId: null,
        allObject: null,
        canSeeCustomer: null,
        loggedUser: null,
        fieldName: {
            type: String,
            default() {
                return 'customer_id';
            },
        },
        fieldId: {
            type: String,
            default() {
                return 'customer_id';
            },
        },
        value: null,
        event: null,
        itemType: null,
        bookingCustomers: {
            default() {
                return [{
                    booking_customer_id:null,
                    booking_customer_share:null,
                    counter:0
                }];
            },
        },
        viewBooking:false,
        viewBookingAddCustomers:false,
        allowMultiCustomers: {
            type: Boolean,
            default: false
        },
      minCustomersCount: {
        type: Number,
        default: 1
      },
      maxCustomersCount: {
        type: Number,
        default: 10
      }
    },
    data() {
        return {
          confirmationDialogId: 'customers-selection-popup-helper',
          add_customer_input: 1, // @todo set this as dynamic from vue
            customerToRemove: null,
           // // @todo set this as dynamic from vue
          show_bill_payer_property:parseInt(this.value.different_bill_payer)===1,
          has_bill_payer:this.value.has_bill_payer,
          customer: this.value,
          customers: this.event && this.event.is_multi_customers ? [...this.bookingCustomers] : [ this.value ],
          localMinCustomersCount: this.minCustomersCount,
          localMaxCustomersCount: this.maxCustomersCount,
        };
    },
    computed: {
        isMobile() {
            return this.getWidth() < 460;
        },
        computedValue() {
          return this.show_bill_payer_property ? 'on' : 'off';
        }
        ,
        check_if_can_view_multi_customer_button(){
            if (this.itemType == 'estimate' || this.itemType ==  'inquiry'){
                return 0;
            }else {
                return 1;
            }

        }
    },
  mounted() {
    this.initiateListeners();
    this.ensureMinCustomers();
  },
  methods: {
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;

        },
    addNewCustomer() {
      if (this.maxCustomersCount >1 && this.customers.length >= this.maxCustomersCount) {
        $.notify('Can`t exceed max customers count');
        return false;
      }else if(this.maxCustomersCount==1){
        this.maxCustomersCount =2;
      }
      const newCounter = this.customers.length + 1;

      this.customers.push({
        'booking_customer_id': null,
        'booking_customer_share': null,
        'counter': newCounter
      });  // Add a new index to the array
    }   ,
    remove_customer_input(customer) {
      return () => {
        return new Promise((resolve, reject) => {
          if ((this.event || {}).is_multi_customers && !customer.counter) {
            let vm = this;
            window.axios.post(`/booking-customers/delete/${customer.booking_customer_id}`, {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
              }
            }).then(function (response) {
              if (response.data.type === 'success') {
                $.notify(response.data.msg, 'success');
                vm.customers.splice(vm.customers.indexOf(customer), 1);
                EventBus.$emit('changeCustomer', [...vm.customers]);
                // Recalculate counters after deletion
                vm.customers.forEach((customer, index) => {
                  customer.counter = index + 1;
                });
                vm.ensureMinCustomers(); // Ensure minimum customers after deletion
              } else {
                $.notify(response.data.msg, 'error');
              }
              resolve(true);
            });
          } else {
            if (this.customers.length > this.minCustomersCount) {
              this.customers.splice(this.customers.indexOf(customer), 1);
              // Recalculate counters after deletion
              this.customers.forEach((customer, index) => {
                customer.counter = index + 1;
              });
              this.ensureMinCustomers(); // Ensure minimum customers after deletion
              resolve(true);
            } else {
              $.notify(`Cannot delete. Minimum number of customers is ${this.minCustomersCount}`);
              reject(false);
            }
          }
        });
      };
    },
    openDeleteModal(customer) {
      const totalCustomers = this.customers.length;

      if (totalCustomers > this.minCustomersCount) {
        this.customerToRemove = customer;
        if(customer.customer_Id){
          $('#deleteCustomerModal').modal('show');
        }else{
          this.customers.splice(this.customers.indexOf(customer), 1);
          // Recalculate counters after deletion
          this.customers.forEach((customer, index) => {
            customer.counter = index + 1;
          });
          this.ensureMinCustomers(); // Ensure minimum customers after deletion
        }
      } else {
        $.notify(`Cannot delete. Minimum number of customers is ${this.minCustomersCount}`);
      }
    },
    handleMaxCustomersCountChange() {

      const newMaxCount = this.maxCustomersCount;
      const currentCount = this.customers.length;

      // Ensure the new max count is at least the minimum count
      if (newMaxCount < this.minCustomersCount) {
        $.notify(`The maximum number of customers cannot be less than the minimum (${this.minCustomersCount}). Setting it to the minimum.`);
        this.maxCustomersCount = this.minCustomersCount;
        return;
      }

      // If the new max count is less than the current count,
      // prompt user for confirmation before removing excess customers
      if (newMaxCount < currentCount) {
        const excessCustomers = currentCount - newMaxCount;

        if (confirm(`Reducing the maximum number of customers will remove ${excessCustomers} customer(s). Are you sure you want to proceed?`)) {
          // Remove empty customer inputs first
          let emptyCustomers = this.customers.filter(customer => !customer.customer_id);
          let nonEmptyCustomers = this.customers.filter(customer => customer.customer_id);

          // Remove required number of customer inputs
          let customersToRemove = [];
          let remainingToRemove = excessCustomers;
          // Remove empty customer inputs first
          if (emptyCustomers.length > 0) {
            customersToRemove = emptyCustomers.slice(0, remainingToRemove);
            remainingToRemove -= customersToRemove.length;
          }

          // If more need to be removed, remove non-empty customer inputs
          if (remainingToRemove > 0) {
            customersToRemove = customersToRemove.concat(nonEmptyCustomers.splice(- remainingToRemove));
          }

          customersToRemove.forEach(customer => {
            this.customers.splice(this.customers.indexOf(customer), 1);
          });

          // Recalculate counters after deletion
          this.customers.forEach((customer, index) => {
            customer.counter = index + 1;
          });
        } else {
          // If user cancels, revert maxCustomersCount to the previous value
          this.maxCustomersCount = currentCount;
        }
      }
    },
    handleMinCustomersCountChange(newMinCount) {
      // Ensure the max count is at least the minimum count
      if (this.maxCustomersCount < newMinCount) {
        this.maxCustomersCount = newMinCount;
      }
        EventBus.$emit('minCustomersCountUpdated', newMinCount);

        this.ensureMinCustomers(); // Ensure minimum customers when min count changes
    },
    ensureMinCustomers() {
      while (this.customers.length < this.minCustomersCount) {
        this.addNewCustomer();
      }
    },
      showHelper(){
        $(`#${this.confirmationDialogId}`).modal('show')
      },
      showPOPUI() {
        window.popupi_alert('Customer Details', "When selecting or adding a 'Customer' for a booking, quote, or inquiry, you can find an existing customer by searching their name, email, business name, or phone number. For new customers, you can create a new profile directly from this list.\n" +
            "<br><br>\n" +
            "To add group customers, ensure the service supports group bookings and specifies the allowed customers number in add/edit booking page. Create or select a booking.\n" +
            "<br><br>\n" +
            "If your business needs to manage various customer dependents, like children for childcare services, vehicles for maintenance businesses, pets for pet care services, or properties for real estate agencies, then OctopusPro's 'Customer Properties' feature is an invaluable tool. This feature allows you to manage and track these dependents, assets, or properties efficiently, thereby enhancing your customer profiles and improving service delivery.\n" +
            "<br><br>\n" +
            "Beyond the standard details, OctopusPro's 'Custom Fields' feature allows you to further customize customer profiles. This feature enables you to record any additional information that is specific to your industry, such as a customer’s date of birth, gender, hobbies, interests, or height. These custom fields can then be used to generate detailed reports for your sales or marketing teams.\n" +
            "<br><br>\n" +
            "To set up 'Customer Properties' or 'Custom Fields', navigate to 'Settings', then 'General Settings', and finally 'Customer Properties' or 'Customer Profile'. In 'Customer Profile', you can add custom fields to your customer profiles.\n" +
            "<br><br>\n" +
            "Remember, detailed and personalized customer profiles enable better service provision. For more information on how to utilize the 'Customer Properties' feature, refer to our help guide at <a href=\"https://help.octopuspro.com/customer-properties\" target=\"_blank\">https://help.octopuspro.com/customer-properties</a>. To learn more about adding 'Custom Fields' to your customer profiles, visit <a href=\"https://help.octopuspro.com/customer-custom-fields\" target=\"_blank\">https://help.octopuspro.com/customer-custom-fields</a>.")
      },
      showHideBillPayer() {
          this.customer.different_bill_payer = this.show_bill_payer_property;
        EventBus.$emit('onBillPayerChanged',this.show_bill_payer_property);
          if (!this.show_bill_payer_property){
              EventBus.$emit('onCustomerChanged',this.customer)
          }
      },
    initiateListeners() {

      EventBus.$on('onBillPayerChanged', value => {
        this.show_bill_payer_property = value;
      });
      EventBus.$on('setNewCustomers', value => {
        this.customers = value;
      });
      EventBus.$on('removeCustomer', customer_id => {
        // get customer index on this.customers array and remove it from the array
        const customerIndex = this.customers.findIndex(customer => customer.customer_id === customer_id);
        //remove it from the array if the customer counter >1
          this.customers.splice(customerIndex, 1);
          if(this.customers.length === 0)
            this.customers.push({
              'booking_customer_id': null,
              'booking_customer_share': null,
              'counter': 1
            });  // Add a new index to the array
      });

    },

    },
  watch:{
    customer:{
      handler: function(value){
          this.$emit('input',value)
      },
      deep: true
    } ,
    customers:{
      handler: function(value){
          if( value && value[0].customer_id){
              this.customer = value[0];
          }
          this.$emit('bookingCustomersChanged', value)

      },
      deep: true
    },
    maxCustomersCount(newMaxCount) {
      this.handleMaxCustomersCountChange(newMaxCount);
    },
    minCustomersCount(newMinCount) {
      this.handleMinCustomersCountChange(newMinCount);
    }

  }
}
</script>

<style scoped>
@media only screen and (min-width: 768px) {
    .no-padding-select-customer{
        padding: 0px !important;
    }
}
.top-7{
  top: 7px;
}
.right-8{
  right: 8px;
}
.custom-mobileStile{
  display: none;
}
.bg-transparent{
  background-color: transparent;
}

.remove_customer_input {
  position: absolute;
  right: 0%;
  top: 6px;
 }
m-b-lg-first:first-child{
  margin-bottom: 30px;
}
.display-none
{
  display: none;
}
.max-min .capacity{
  //styleName: Title/Left/H3;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #2E4051;

}
.max-min .minmum , .max-min .maxmum,.max-min input
{
  font-family: Roboto;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  text-align: left;
  color: #2E4051;

}
.max-min input{
  width: 48px ;
  height:  48px ;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid;
  margin-top: 10px;
text-align: center;

}
.max-min input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.max-min input[type=number] {
  -moz-appearance: textfield;
}
.ts-control{
  z-index: unset !important;
}
.m-bottom-30
{
  margin-bottom: 30px
}
</style>
